import axios from 'axios'
import { BASE_URL } from '../global/Constants/Constants'

const api = axios.create({
	baseURL: BASE_URL,
})

api.interceptors.request.use((config) => {
	const sessionId = localStorage.getItem('Session_Id')
	if (sessionId) {
		config.headers['Session_Id'] = sessionId
	}
	return config
})

async function handleResponse(response) {
	if (response.data.IsSuccess) {
		return response.data.Data
	} else {
		const error = response.data.Message
		throw new Error(error)
	}
}

function handleError(error) {
	throw error
}

export { api, handleResponse, handleError }
